import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { Text } from "@cars24/turbo-web/lib/text";
import Leaf from "./images/leaf.svg";
import MapPin from "./images/map-pin.svg";
import Slider from "../../shared/slick-wrapper";
import LazyImage from "../../shared/lazy-image";

const EliteStores = ({
    section
}) => {

    const {pageSection = {} } = section || {};
    const { title = "CARS24 ELITE in India", sectionData } = pageSection || {};

    const settings = {
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 1500,
        arrow: false,
        speed: 800,
        dots: false,
        pauseOnHover: false,
        swipeToSlide: true,
        touchMove: true,
        rtl: false,
        cssEase: "ease-in-out",
        easing: "ease-in-out"
    };

    return (
        <div styleName={"styles.eliteStoresWrapper"}>
            <div styleName={"styles.title"}>
                <img src={Leaf} alt="leaf"/>
                <Text
                    align="center"
                    as="h2"
                    fontWeight="semibold"
                    size="650"
                    transform="none"
                    color={"#FFFFFF"}
                >
                    {title}
                </Text>
                <img src={Leaf} alt="leaf" styleName={"styles.rightLeaf"}/>
            </div>

            <Slider {...settings}>
                {
                    sectionData.map((item, index) => (
                        <div styleName={"styles.storeCard"} key={`elite-stores-${index}`} onClick={() => window.open(item.primaryCtaUrl)}>
                            <div styleName={"styles.storeImg"}>
                                <LazyImage src={item.image.url} alt={item.image.alternativeText} />
                            </div>
                            <div styleName={"styles.locationTitle"}>
                                <img src={MapPin} alt="location" width="32px" height="32px" styleName={"styles.location"} />
                                <Text
                                    align="left"
                                    as="p"
                                    fontWeight="medium"
                                    size="400"
                                    transform="none"
                                    color={"#FFFFFF"}
                                >
                                    {item.title}
                                </Text>
                            </div>
                            {/* <Text
                                    align="center"
                                    as="h2"
                                    fontWeight="semibold"
                                    size="500"
                                    transform="none"
                                    color={"#FFFFFF"}
                                >
                                    {item.subTitle}
                                </Text> */}
                        </div>
                    ))
                }
            </Slider>
        </div>
    );
};

EliteStores.propTypes = {
    section: PropTypes.object
};

export default EliteStores;
